import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Modal, Tooltip, OverlayTrigger, Badge, Dropdown } from 'react-bootstrap';


//components
import applicationRouter from '~/hoc/applicationRouter'
import withLocalization from '~/hoc/withLocalization';
import { checkUserPermissions } from '../../../library/stores/userStore';
import CopyWeekModal from './CopyForm';
import ShiftAllowanceManagement from './ShiftAllowanceManagement';
import UrgentCallManagement from './UrgentCallManagement';
import FutureScheduleEntryBadge from '../../../components/FutureScheduleEntryBadge';
import AutoTimeRecordingBadge from '../../../components/AutoTimeRecordingBadge';

// Widgets
import { ProjectsWidget } from '../../../components/GenericForm/Widgets/ProjectsWidget';

//elements
import Select from '../../../elements/Select';
import CustomCheckbox from '../../../components/CustomCheckbox/CustomCheckbox';
import CustomButton from '../../../components/CustomButton/CustomButton';
import Button from '~/components/CustomButton/CustomButton.jsx';
import DatePicker from '../../../components/DatePicker/DatePicker';

//utils
import { timeFormat } from '../../../utils/dateFormat';
import moment from 'moment/min/moment-with-locales';
import scheduleConfig from '../../../components/Scheduler/config'
import { ClockCheckIcon } from '../../../utils/constants'

//styles
import './Schedule.css';

//assets
import CloseIcon from '~/assets/img/modal-close-icon.svg';
import Delete from '~/assets/img/deleting.svg';
import MorningBlack from '~/assets/img/MorningBlack.svg';
import MorningWhite from '~/assets/img/MorningWhite.svg';
import AfternoonBlack from '~/assets/img/AfternoonBlack.svg';
import AfternoonWhite from '~/assets/img/AfternoonWhite.svg';
import NightBlack from '~/assets/img/NightBlack.svg';
import NightWhite from '~/assets/img/NightWhite.svg';
import CloseModalIcon from '../../../assets/img/CloseApproveModalIcon.svg';

const scheduleCalenderTypeOptions = [{ value: '1', label: 'Week', title: 'Week' },
{ value: '2', label: 'Month', title: 'Month' }];
const scheduleResourceSortingOptions = [{ value: 'sortableName', label: 'Sort By Members', title: 'Sort By Members' },
{ value: 'start_time', label: 'Sort By Start Time', title: 'Sort By Start Time' }];
const scheduleResourceFilterOptions = [{ value: null, label: 'All', title: 'All' },
{ value: true, label: 'Scheduled', title: 'Scheduled' },
{ value: false, label: 'Not Scheduled', title: 'Not Scheduled' }];
const scheduleShiftTypeFilter = [{ value: '4,12', label: 'Morning', title: "Morning", image: MorningBlack, imageSelected: MorningWhite },
{ value: '12,20', label: 'Afternoon', title: "Afternoon", image: AfternoonBlack, imageSelected: AfternoonWhite },
{ value: '20,4', label: 'Night', title: "Night", image: NightBlack, imageSelected: NightWhite }];
const pmManagedShiftsOptions = [{ value: null, label: 'All Shifts', title: 'All Shifts' },
{ value: true, label: 'Managed Shifts', title: 'Managed Shifts' },
{ value: false, label: 'View Only Shifts', title: 'View Only Shifts' }];

class ScheduleWeekHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            project_id: props.scheduleStore.filters.project,
            sortFilterValue: props.scheduleStore.filters.sortFilterValue,
            resourceFilterValue: props.scheduleStore.filters.resourceFilterValue,
            pmManagedShiftsFilterValue: props.scheduleStore.filters.pmManagedShiftsFilterValue,
            dayDurationFilterValue: props.scheduleStore.filters.dayDurationFilterValue,
            showFilterMenu: false,
            copying: false,
            showShiftAllowanceManagement: false,
            showUrgentShiftModal: false,
            employeeSearchName: props.scheduleStore.filters.employeeSearchName || ''
        }
    }

    handleGoToWeekChange = (e) => {
        const val = e.target.value;
        if (val && this.props.onGoToWeek) this.props.onGoToWeek(val);
    }

    handleCloseUrgentShiftModal = () => {
        this.setState({ showUrgentShiftModal: false })
        this.props.reloadData()
    }

    handleEmployeeSearch = (isClear = false) => {
        const { employeeSearchName } = this.state;
        if (!isClear && (!employeeSearchName || employeeSearchName.trim() === "")) return;
        this.props.scheduleStore.setFilter("employeeSearchName", employeeSearchName);
        this.props.scheduleStore.clearLoadedPages();
        this.setState({ loading: true }, async () => {
            await this.props.handleEmployeeSearchChange();
            this.setState({ loading: false });
        });
    }

    handleEmployeeSearchClear = () => {
        this.setState({ employeeSearchName: '' }, () => {
            this.handleEmployeeSearch(true);
        });
    }

    onViewChange = (e) => {
        const { onViewChange, schedulerData } = this.props;
        const viewType = e.value;
        const isEventPerspective = e.value === 1;
        onViewChange(schedulerData, { viewType, isEventPerspective });
    };

    handleProjectChange(value) {
        this.props.scheduleStore.setFilter("project", value);
        this.setState({ project_id: value }, () => {
            this.props.handleProjectChange(value);
        });
    };

    renderCurrentWeekBanner = () => {
        const { t, schedulerData, onGoToWeek } = this.props;
        if (!schedulerData || !schedulerData.startDate) return null;
        const isCurrentWeek = moment(schedulerData.startDate).isSame(moment(), 'isoWeek');
        if (isCurrentWeek) return null;
        return (
            <div className="current-week-banner">
                <span
                    className="current-week-banner__btn"
                    onClick={() => onGoToWeek && onGoToWeek(moment().format('GGGG-[W]WW'))}
                >
                    <span className="current-week-banner__arrow">&#8593;</span>
                    {t('To Current Week')}
                </span>
            </div>
        );
    }

    goNext = () => {
        const { nextClick, schedulerData } = this.props;
        nextClick(schedulerData);
    };

    goBack = () => {
        const { prevClick, schedulerData } = this.props;
        prevClick(schedulerData);
    };

    handleClosesFilterMenu = () => {
        this.setState((state) => ({
            showFilterMenu: !state.showFilterMenu,
        }))
    }

    handleFilterChange = (event, filterName, callBackFunction = null) => {
        this.props.scheduleStore.setFilter(filterName, event);
        this.setState({ [filterName]: event },
            () => {
                if (!callBackFunction) this.props.checkFiltersAndSetResources(this.props.schedulerData, true);
                else callBackFunction();
            })
    }

    handleApproveTimelogsButton = () => {
        const { commonStore, scheduleStore, t } = this.props;
        const selectedShifts = Object.values(scheduleStore.shiftEventSelectionData).filter(ele => ele.checked && ele.details.timelogCount);
        if (!selectedShifts.length)
            return commonStore.addNotification(t('These scheduled hours are missing on the timesheet. Please enter the missing hours before approving it'), null, 'warning');

        if (selectedShifts.every(ele => !ele.details.timelogsToBeApprovedCount))
            return commonStore.addNotification(t("Selected hours are already approved or in progress"), null, 'warning');

        this.props.handleTimesheetApprovalModal()
    }

    translateLabels() {
        const { t } = this.props;
        const optionsArrayToBeTranslated = [scheduleConfig.scheduleListingViews, scheduleCalenderTypeOptions,
            scheduleResourceSortingOptions, scheduleResourceFilterOptions, scheduleShiftTypeFilter, pmManagedShiftsOptions];
        optionsArrayToBeTranslated.forEach(_array => _array.forEach(item => {
            item.label = t(item.title);
        }));
    }

    parseShiftTimeToDateTimeFormat = (shiftTimeRangeString, getDateTimeRules) => {
        const shiftTimeRangeInArray = shiftTimeRangeString.split(',').map(e => timeFormat(Number(e) * 60, getDateTimeRules()));
        return shiftTimeRangeInArray.join(' - ');
    }

    renderScheduleLegend() {
        const { t, commonStore } = this.props;
        const loginRules = commonStore?.config?.client?.data?.loginRules;
        const isAutoScheduleMode = loginRules?.autoTimelogs === 'autoschedule';
        const showFutureLegend = isAutoScheduleMode;
        const showAutoLegend = isAutoScheduleMode && loginRules?.allowShiftToEnableDisableAutoTimesheet;
        const showRosterLegend = commonStore?.config?.client?.data?.basicRules?.workPlanSettings?.allow_work_hours_settings;
        const showRecurringLegend = commonStore?.config?.client?.allow_company_shifts && commonStore?.config?.client?.data?.basicRules?.allowMembersToManageScheduleShift;
        if (!showFutureLegend && !showAutoLegend && !showRosterLegend && !showRecurringLegend) return null;

        return (
            <div className='d-flex align-items-center justify-content-end gap-3 flex-wrap my-0'>
                {showFutureLegend && (
                    <span className='d-flex align-items-center gap-1 font-size-12'>
                        <FutureScheduleEntryBadge />
                        {t('Future Time Recording')}
                    </span>
                )}
                {showAutoLegend && (
                    <span className='d-flex align-items-center gap-1 font-size-12'>
                        <AutoTimeRecordingBadge style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '13px', height: '13px', lineHeight: '1', padding: 0, fontWeight: 'bold' }} />
                        {t('Auto time recording')}
                    </span>
                )}
                {showRosterLegend && (
                    <span className='d-flex align-items-center gap-1 font-size-12'>
                        <i className="fa fa-calendar-check" style={{ color: '#6C3EB5' }} />
                        {t('Roster Shift')}
                    </span>
                )}
                {showRecurringLegend && (
                    <span className='d-flex align-items-center gap-1 font-size-12'>
                        <i className="fa fa-sync" style={{ color: '#6C3EB5' }} />
                        {t('Recurring Shift')}
                    </span>
                )}
            </div>
        );
    }

    renderTools(isMember, canMemberCreateShift, rosterAppliesToMember, isFutureEntryOnlyMember) {
        const { t, isAvailibiltyFeatureEnabled, isShiftRequestsEnabled, shiftAllowanceStore, commonStore } = this.props;
        const isShiftAllowanceExtraPaymentActive = commonStore.config?.client?.data?.extraPayments.some(ele => ele.code === 'shift_allowance' && ele.isActive);
        const isUrgentCallSettingAvailable = commonStore.checkIfClientHasUrgentCallSettings(null, false, false);
        const urgentWorkSettings = commonStore.config && commonStore.config.client && commonStore.config.client.data && commonStore.config.client.data.basicRules && commonStore.config.client.data.basicRules.urgentWorkSettings;
        const allowUrgentWork = urgentWorkSettings && urgentWorkSettings.allowUrgentWork;
        if (isMember) {
            return (
                <>
                    {canMemberCreateShift && (
                        <OverlayTrigger
                            key="memberCreateShiftsBtn"
                            placement="bottom"
                            overlay={<Tooltip id="tooltip-member-create-shifts">{t(isFutureEntryOnlyMember ? 'Create Future Entry' : 'Create Shifts')}</Tooltip>}
                        >
                            <CustomButton fill id="schedule-member-bulk-shift-btn"
                                onClick={() => this.props.newMemberBulkShiftEvent()}>
                                {t(isFutureEntryOnlyMember ? 'Create Future Entry' : 'Create Shifts')}
                            </CustomButton>
                        </OverlayTrigger>
                    )}
                    {canMemberCreateShift && !isFutureEntryOnlyMember && commonStore?.config?.client?.allow_company_shifts && (
                        <OverlayTrigger
                            key="memberRecurringShiftsBtn"
                            placement="bottom"
                            overlay={<Tooltip id="tooltip-member-recurring-shifts">{t('Recurring Shifts')}</Tooltip>}
                        >
                            <CustomButton id="schedule-member-recurring-shift-btn"
                                onClick={() => this.props.handleShowRecurringShiftModal()}>
                                <span className="fw-bold">{t('Recurring Shifts')}</span>
                            </CustomButton>
                        </OverlayTrigger>
                    )}
                    {canMemberCreateShift && !rosterAppliesToMember && !isFutureEntryOnlyMember && (
                        <OverlayTrigger
                            key="memberCopyShiftsBtn"
                            placement="bottom"
                            overlay={<Tooltip id="tooltip-member-copy-shifts">{t('Copy')} {t('Weeks')}</Tooltip>}
                        >
                            <CustomButton fill id="schedule-member-copy-btn"
                                onClick={() => this.setState({ copying: true })}>
                                {t('Copy')}&nbsp;{t('Weeks')}
                            </CustomButton>
                        </OverlayTrigger>
                    )}
                    {isAvailibiltyFeatureEnabled && (
                        <OverlayTrigger
                            key="availabilityBtn"
                            placement="bottom"
                            overlay={<Tooltip id="tooltip-bottom">{t('Add Availability')}</Tooltip>}
                        >
                            <CustomButton fill id="schedule-availability-btn"
                                onClick={() => this.props.viewAvailabilityAssign()}>
                                {t('Availability')}
                            </CustomButton>
                        </OverlayTrigger>
                    )}
                    <OverlayTrigger
                        placement="bottom"
                        overlay={<Tooltip id="tooltip-holidays-member">{t("View Holidays")}</Tooltip>}
                    >
                        <CustomButton fill id="schedule-holidays-btn"
                            onClick={() => this.props.openHolidayView && this.props.openHolidayView()}>
                            {t('Holidays')}
                        </CustomButton>
                    </OverlayTrigger>
                    {urgentWorkSettings?.allowUrgentWorkForMembers && (
                        <Dropdown className="d-inline">
                            <Dropdown.Toggle id="dropdown-autoclose-inside" style={{ padding: "6px" }}>
                                {t('More Actions')}
                                {!!shiftAllowanceStore?.allShiftAllowance?.length &&
                                    <Badge className='ms-1 bg-danger'>{shiftAllowanceStore?.allShiftAllowance?.length}</Badge>
                                }
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                {allowUrgentWork && (
                                    <Dropdown.Item
                                        disabled={!isUrgentCallSettingAvailable}
                                        title={isUrgentCallSettingAvailable ? `${t('Manage')} ${t('Urgent work')}` : t("Please configure urgent work settings, contact administrator")}
                                        onClick={() => this.setState({ showUrgentShiftModal: true })}>
                                        <div>
                                            {t('Urgent Planner')}
                                        </div>
                                    </Dropdown.Item>
                                )}
                            </Dropdown.Menu>
                        </Dropdown>
                    )}
                </>
            )
        }
        return (
            <>
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {t('Open to view more actions')}
                        </Tooltip>
                    }
                >
                    <div className='custom-style-userlist'>
                        <Dropdown className="d-inline">
                            <Dropdown.Toggle id="dropdown-autoclose-inside" style={{ padding: "6px" }}
                                disabled={isMember}
                            >
                                {t('More Actions')}
                                {!!shiftAllowanceStore?.allShiftAllowance?.length &&
                                    <Badge className='ms-1 bg-danger'>{shiftAllowanceStore?.allShiftAllowance?.length}</Badge>
                                }
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => this.setState({ copying: true })}>
                                    <div>
                                        {t('Copy')}&nbsp;{t('Weeks')}
                                    </div>
                                </Dropdown.Item>
                                <Dropdown.Item
                                    onClick={() => this.setState((state) => ({ showFilterMenu: !state.showFilterMenu }))}>
                                    <div>
                                        {`${t('Filter')} ${t('shifts')}`}
                                    </div >
                                </Dropdown.Item >
                                <Dropdown.Item
                                    onClick={() => this.props.openHolidayView && this.props.openHolidayView()}>
                                    <div>
                                        {t('Holidays')}
                                    </div>
                                </Dropdown.Item>
                                {(isAvailibiltyFeatureEnabled || isShiftRequestsEnabled) && <Dropdown.Item
                                    onClick={() => this.props.openManagementModal()}>
                                    <div>
                                        {t('Management')}
                                    </div>
                                </Dropdown.Item>}
                                <Dropdown.Item
                                    onClick={() => this.props.startCopyToNextWeek()}>
                                    <div>
                                        {t('Quick Copy')}
                                    </div>
                                </Dropdown.Item>
                                {isShiftAllowanceExtraPaymentActive && <Dropdown.Item
                                    title={t('Manage Shift allowance for employees')}
                                    onClick={() => this.setState({ showShiftAllowanceManagement: true })}>
                                    <div>
                                        {t('Shift Allowance')}
                                        <Badge className='ms-2 bg-secondary'>{shiftAllowanceStore?.allShiftAllowance?.length}</Badge>
                                    </div>
                                </Dropdown.Item>}
                                <Dropdown.Item
                                    onClick={() => this.props.filterTodayShifts()}>
                                    <div>
                                        {t('Shifts Today')}
                                    </div>
                                </Dropdown.Item>
                                {allowUrgentWork && (
                                    <Dropdown.Item
                                        disabled={!isUrgentCallSettingAvailable}
                                        title={isUrgentCallSettingAvailable ? `${t('Manage')} ${t('Urgent work')}` : t("Please configure urgent work settings, contact administrator")}
                                        onClick={() => this.setState({ showUrgentShiftModal: true })}>
                                        <div>
                                            {t('Urgent Planner')}
                                        </div>
                                    </Dropdown.Item>
                                )
                                }
                            </Dropdown.Menu >
                        </Dropdown >
                    </div >
                </OverlayTrigger >
                <OverlayTrigger
                    placement="top"
                    overlay={
                        <Tooltip id="tooltip-top">
                            {t('Bulk Shift')}
                        </Tooltip>
                    }
                >
                    <div className='custom-style-userlist ms-1'>
                        <Dropdown className="d-inline">
                            <Dropdown.Toggle id="dropdown-autoclose-inside" style={{ padding: "6px" }}
                                disabled={isMember}
                            >
                                {t('Bulk Shift')}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item
                                    onClick={() => this.props.newBulkEvent()}>
                                    <div>
                                        {t('Bulk Shift')}
                                    </div>
                                </Dropdown.Item>

                                {commonStore?.config?.client?.allow_company_shifts && <Dropdown.Item
                                    onClick={this.props.handleShowRosterShiftModal}>
                                    <div>
                                        {t('Roster Shifts')}
                                    </div>
                                </Dropdown.Item>}
                                {/* recurring plans are PM/member only, for their own shifts */}
                                {commonStore?.config?.client?.allow_company_shifts && this.props.userStore.currentUser.user_type === 'pm' && <Dropdown.Item
                                    onClick={this.props.handleShowRecurringShiftModal}>
                                    <div>
                                        {t('Recurring Shifts')}
                                    </div>
                                </Dropdown.Item>}
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </OverlayTrigger>
            </>
        );
    }

    render() {
        const { t, schedulerData, getDateTimeRules, scheduleStore, userStore, urgentCallEditing, commonStore } = this.props;
        const { sortFilterValue, resourceFilterValue, pmManagedShiftsFilterValue, copying, showShiftAllowanceManagement, showUrgentShiftModal, employeeSearchName } = this.state;
        const isMember = userStore.currentUser.user_type === 'member';
        const allowMembersToManageScheduleShift = commonStore?.config?.client?.data?.basicRules?.allowMembersToManageScheduleShift || false;
        const allowWorkHoursSettings = commonStore?.config?.client?.data?.basicRules?.workPlanSettings?.allow_work_hours_settings || false;
        const isNoDepartmentMember = userStore.currentUser.employee_type === 'no_department';
        // department members work through the roster while it is enabled, so Roster view is required for them;
        // creating/deleting shifts additionally requires either the md_Shift create/edit/delete permission, or (future-entry-only members) the manageFutureScheduleEntry permission
        const rosterAppliesToMember = allowWorkHoursSettings && !isNoDepartmentMember;

        // future entries need auto-schedule cron mode - dead permission otherwise
        const isAutoScheduleMode = commonStore?.config?.client?.data?.loginRules?.autoTimelogs === 'autoschedule';
        const hasCreateEditDeletePermission = checkUserPermissions('md_Shift', 'createEditAndDelete');
        const hasFutureScheduleEntryPermission = checkUserPermissions('md_Shift', 'manageFutureScheduleEntry') && isAutoScheduleMode;

        // a future-entry-only member (no createEditAndDelete) never browses the roster - they're only
        // flagging a future date - so md_Roster.view shouldn't gate them the way it gates real roster users
        const isFutureEntryOnlyMember = hasFutureScheduleEntryPermission && !hasCreateEditDeletePermission;
        const canMemberCreateShift = isMember && allowMembersToManageScheduleShift
            && (!rosterAppliesToMember || checkUserPermissions('md_Roster', 'view') || isFutureEntryOnlyMember)
            && (hasCreateEditDeletePermission || hasFutureScheduleEntryPermission);
        const currentShiftsLength = scheduleStore.shiftEventSelectionData ?
            Object.keys(scheduleStore.shiftEventSelectionData).length : 0;
        const currentTimesheetsToApprove = scheduleStore.shiftEventSelectionData
            && Object.values(scheduleStore.shiftEventSelectionData).filter(ele => ele.checked).length;
        let getWeek = schedulerData.getDateWeek('1');
        let dateLabel = schedulerData.getDateLabel(1);
        this.translateLabels();
        const { allow_work_hours_settings = false } = commonStore?.config?.client?.data?.basicRules?.workPlanSettings || {};
        const shiftOptions = scheduleShiftTypeFilter.map(item => ({
            ...item,
            displayLabel: `${item.label} (${this.parseShiftTimeToDateTimeFormat(item.value, getDateTimeRules)})`
        }));
        const selectedValue = shiftOptions.find(opt => opt.value === this.state.dayDurationFilterValue) || null;

        let schedulerHeader = (
            <>
                <div className="RBS-Scheduler-config d-flex align-items-start justify-content-space-between">
                    <div className='d-flex align-items-start gap-2 flex-wrap'>

                        {!isMember && <div style={{ minWidth: '100px' }}>
                            <Select
                                options={scheduleConfig.scheduleListingViews}
                                defaultValue={scheduleConfig.scheduleListingViews[0]}
                                value={scheduleConfig.scheduleListingViews.find(e => e.value === scheduleStore.filters.currentView)}
                                onChange={event => this.props.onListViewChange(event)}
                            />
                        </div>}

                        <div className="custom_dropdown">
                            <Select options={scheduleCalenderTypeOptions}
                                defaultValue={scheduleCalenderTypeOptions[0]}
                                onChange={event => this.onViewChange(event)} />
                        </div>

                        {!isMember && (
                            <div style={{ minWidth: '100px' }}>
                                <ProjectsWidget
                                    value={this.state.project_id || 'all'}
                                    onChange={(id) => this.handleProjectChange(id)}
                                    allLabel={t('All projects')}
                                    allowAll
                                />
                            </div>
                        )}
                    </div>

                    <CustomButton schedule style={{ cursor: 'pointer', position: 'relative', whiteSpace: 'nowrap' }}>
                        <div className='d-flex align-items-center gap-2'>
                            <span onClick={this.goBack} style={{ zIndex: 11, padding: '5px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><b className="scheduleCaret rotate-90"></b></span>
                            <DatePicker
                                selected={new Date(this.props.schedulerData.startDate)}
                                onChange={(date) => {
                                    const weekVal = moment(date).format('GGGG-[W]WW');
                                    if (this.props.onGoToWeek) this.props.onGoToWeek(weekVal);
                                }}
                                todayButton={t("Current Week")}
                                showWeekNumbers
                                customInput={
                                    <div style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', flexWrap: 'nowrap', minWidth: 'max-content' }}>
                                        <span className="week_block" size="sm">{getWeek}</span>
                                        <span className="header2-text-label">
                                            {dateLabel} , {moment(this.props.schedulerData.startDate).format('YYYY')}
                                        </span>
                                    </div>
                                }
                                popperPlacement="bottom-start"
                            />
                            <span onClick={this.goNext} style={{ zIndex: 11, padding: '5px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}><b className="scheduleCaret rotate-270"></b></span>
                        </div>
                    </CustomButton>
                    <div className='d-flex justify-content-end align-items-center gap-1 flex-wrap'>
                        {this.renderTools(isMember, canMemberCreateShift, rosterAppliesToMember, isFutureEntryOnlyMember)}
                    </div>
                    <div className='w-100'>
                        {this.renderScheduleLegend()}
                    </div>
                </div>

                <div className='d-flex justify-content-space-between align-items-center'>
                    <div className='d-flex align-items-center'>
                        <div style={{ width: '250px' }}>
                            <Select
                                options={shiftOptions}
                                value={selectedValue}
                                onChange={opt => this.handleFilterChange(opt ? opt.value : "", "dayDurationFilterValue", this.props.handleDayDurationChange)}
                                placeholder={this.props.t("Working Shift")}
                                isClearable={true}
                                formatOptionLabel={(data) => (
                                    <div className="d-flex align-items-center">
                                        <span style={{ fontSize: '12px' }}>
                                            {data.displayLabel}
                                        </span>
                                    </div>
                                )}
                            />
                        </div>
                        {!isMember && (
                            <div className="conversation-search m-2" style={{ width: '250px' }}>
                                <input
                                    type="text"
                                    className="conversation-search-input"
                                    placeholder={t('Search by employee name')}
                                    onChange={(e) => this.setState({ employeeSearchName: e.target.value })}
                                    onKeyDown={(e) => {
                                        if (e.code === 'Enter')
                                            this.handleEmployeeSearch();
                                    }}
                                    value={employeeSearchName}
                                />
                                {employeeSearchName ? (
                                    <i className="fa fa-times conversation-search-icon cursor-pointer"
                                        onClick={this.handleEmployeeSearchClear}
                                        style={{ color: '#999' }}
                                    />
                                ) : (
                                    <i className="fa fa-search conversation-search-icon cursor-pointer"
                                        onClick={this.handleEmployeeSearch}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                    {!isMember && allow_work_hours_settings &&
                        <div>
                            <Button onClick={() => {
                                this.props.router.navigate('/admin/roster');
                            }}>
                                {t('Roster')}
                            </Button>
                        </div>
                    }
                    <div className='ml-10 d-flex'>
                        {!isMember &&
                            <>
                                <OverlayTrigger
                                    key="selectAllShiftsBtn"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip-bottom">
                                            {currentShiftsLength ?
                                                t("Select/Deselect All Shifts")
                                                : t("No shifts to select")}
                                        </Tooltip>
                                    }
                                >
                                    <div className='d-flex me-2 mb-1'>
                                        <CustomCheckbox
                                            labelClassName={"font-size-10"}
                                            isChecked={this.props.scheduleStore.isAllShiftEventSelected}
                                            onChange={value => this.props.scheduleStore.toggleSelectAllShiftEvent(value)}
                                            label={t("Select All")}
                                            disabled={!currentShiftsLength}
                                        />
                                    </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    key="approveTimesheetBtn"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip-bottom">
                                            {currentTimesheetsToApprove ?
                                                t("Approve Timesheets from selecetd shifts")
                                                : t("No timesheets to approve")}
                                        </Tooltip>
                                    }
                                >
                                    <CustomButton id="schedule-month-copy" schedule scheduleSm me2
                                        style={{ fontSize: '10px' }}
                                        onClick={this.handleApproveTimelogsButton}
                                        disabled={!currentTimesheetsToApprove}
                                    >
                                        {ClockCheckIcon({ width: 20, fillColor: '#038102' })}
                                        &nbsp;{t('Timesheet')}
                                    </CustomButton>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    key="approveShiftsBtn"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip-bottom">
                                            {currentTimesheetsToApprove ? t("Approve shifts") : t("No shift to approve")}
                                        </Tooltip>
                                    }
                                >
                                    <CustomButton id="schedule-month-copy" schedule scheduleSm me2
                                        style={{ fontSize: '10px' }}
                                        onClick={this.props.handleShiftApproved}
                                        disabled={!currentTimesheetsToApprove}
                                    >
                                        {ClockCheckIcon({ width: 20, fillColor: '#038102' })}
                                        &nbsp;{t('shifts')}
                                    </CustomButton>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    key="deleteShiftsBtn"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip-bottom">
                                            {currentShiftsLength ? t("Delete Selected Shifts") : t("Please selecct shifts to delete")}
                                        </Tooltip>
                                    }
                                >
                                    <CustomButton id="schedule-month-copy me-2" schedule scheduleSm me2
                                        style={{ fontSize: '10px' }}
                                        onClick={this.props.handleMultiDelete}
                                        disabled={!currentShiftsLength}
                                    >
                                        <img className='m-0' src={Delete} alt='delete-btn' width={15} />
                                        &nbsp; {t('Delete')}
                                    </CustomButton>
                                </OverlayTrigger>
                            </>
                        }
                        {canMemberCreateShift &&
                            <>
                                <OverlayTrigger
                                    key="selectAllMemberShiftsBtn"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip-bottom">
                                            {currentShiftsLength ? t("Select/Deselect All Shifts") : t("No shifts to select")}
                                        </Tooltip>
                                    }
                                >
                                    <div className='d-flex me-2 mb-1'>
                                        <CustomCheckbox
                                            labelClassName={"font-size-10"}
                                            isChecked={scheduleStore.isAllShiftEventSelected}
                                            onChange={value => scheduleStore.toggleSelectAllShiftEvent(value)}
                                            label={t("Select All")}
                                            disabled={!currentShiftsLength}
                                        />
                                    </div>
                                </OverlayTrigger>
                                <OverlayTrigger
                                    key="deleteMemberShiftsBtn"
                                    placement="bottom"
                                    overlay={
                                        <Tooltip id="tooltip-bottom">
                                            {currentShiftsLength ? t("Delete Selected Shifts") : t("Please select shifts to delete")}
                                        </Tooltip>
                                    }
                                >
                                    <CustomButton id="schedule-member-delete-shifts" schedule scheduleSm me2
                                        style={{ fontSize: '10px' }}
                                        onClick={this.props.handleMultiDelete}
                                        disabled={!currentShiftsLength}
                                    >
                                        <img className='m-0' src={Delete} alt='delete-btn' width={15} />
                                        &nbsp; {t('Delete')}
                                    </CustomButton>
                                </OverlayTrigger>
                            </>
                        }
                    </div>
                </div>
                <Modal
                    className="modal right fade filter modal_revised"
                    show={this.state.showFilterMenu}
                    onHide={this.handleClosesFilterMenu}
                >
                    <Modal.Header className='modal-header__revised'>
                        <div className='modal-header__revised__closebtn'
                            onClick={() => this.setState((state) => ({ showFilterMenu: !state.showFilterMenu }))} >
                            <img
                                src={CloseIcon}
                                className="cursor-pointer"
                                alt='close_button'
                            />
                        </div>
                        <Modal.Title>{t('Filter')}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className='mt-4'>
                            <div className='d-flex'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="27px" height="27px" viewBox="0 0 24 24"><path fill="#2550ac" d="M19 3h-1V1h-2v2H8V1H6v2H4.75c-.44.07-.85.27-1.17.58c-.31.32-.51.73-.58 1.17v14.5c.07.44.27.85.58 1.17c.32.31.73.51 1.17.58H15v-2H5V9h14v2h2V5c0-1.11-.89-2-2-2m0 4H5V5h14v2m-2 14l1.8 1.77c.5.5 1.2.1 1.2-.49V18l2.8-3.4A1 1 0 0 0 22 13h-7c-.8 0-1.3 1-.8 1.6L17 18v3"></path></svg>
                                <div className='ms-2'>
                                    {`${t('Filter')} by:`} {resourceFilterValue && !!resourceFilterValue.value ? resourceFilterValue.label : ""}
                                </div>
                            </div>
                            <Select className="min-width-100"
                                options={scheduleResourceFilterOptions}
                                value={resourceFilterValue ? resourceFilterValue : scheduleResourceFilterOptions[0]}
                                onChange={event => this.handleFilterChange(event, "resourceFilterValue")}
                            />
                        </div>
                        <div className={`${this.props.currentView ? 'opacity-50' : ''} mt-4`}>
                            <div className='d-flex'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="27px" height="27px" viewBox="0 0 24 24"><path fill="#2550ac" d="m18 21l-4-4h3V7h-3l4-4l4 4h-3v10h3M2 19v-2h10v2M2 13v-2h7v2M2 7V5h4v2H2Z"></path></svg>
                                <div className='ms-2'>
                                    {sortFilterValue ? t(`${sortFilterValue.label}`) : ""}
                                </div>
                            </div>
                            <Select className="min-width-100"
                                options={scheduleResourceSortingOptions}
                                defaultValue={sortFilterValue ? sortFilterValue : scheduleResourceSortingOptions[0]}
                                onChange={event => this.handleFilterChange(event, "sortFilterValue")}
                                isDisabled={this.props.currentView}
                            />
                        </div>
                        {userStore.currentUser.user_type === 'pm' &&
                            <div className='mt-4'>
                                <div className='d-flex'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="27px" viewBox="0 0 24 24"><path fill="#2550ac" d="M3 21V3h18v10.325q-.475-.275-.962-.5t-1.038-.4V11h-3.325v1q-.525.025-1.025.075t-.975.175V11h-3.35v2.775q-.6.45-1.137 1.013T8.2 16H5v3h2.05q.25.55.538 1.05T8.2 21zm2-7h3.325v-3H5zm0-5h14V5H5zm11 14q-2.275 0-4.2-1.2T9 18.5q.875-2.1 2.8-3.3T16 14t4.2 1.2t2.8 3.3q-.875 2.1-2.8 3.3T16 23m0-2q1.05 0 1.775-.725T18.5 18.5t-.725-1.775T16 16t-1.775.725T13.5 18.5t.725 1.775T16 21m0-1q-.625 0-1.063-.437T14.5 18.5t.438-1.062T16 17t1.063.438t.437 1.062t-.437 1.063T16 20" /></svg>
                                    <div className='ms-2'>
                                        {t('Show shifts')}: {pmManagedShiftsFilterValue && !!pmManagedShiftsFilterValue.value ? pmManagedShiftsFilterValue.label : ""}
                                    </div>
                                </div>
                                <Select className="min-width-100"
                                    options={pmManagedShiftsOptions}
                                    value={pmManagedShiftsFilterValue ? pmManagedShiftsFilterValue : pmManagedShiftsOptions[0]}
                                    onChange={event => this.handleFilterChange(event, "pmManagedShiftsFilterValue")}
                                />
                            </div>
                        }
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="d-flex justify-content-end gap-2">
                            <Button variant="outline-secondary" onClick={() => this.setState({ showFilterMenu: false })}>
                                {t('Cancel')}
                            </Button>
                            <Button fill dynamic_lg onClick={() => {
                                this.setState({ showFilterMenu: false });
                            }}>
                                {t('Save')}
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
                {
                    copying &&
                    <CopyWeekModal finish={() => this.setState({ copying: false })} viewModel={schedulerData} />
                }
                {
                    showShiftAllowanceManagement &&
                    <ShiftAllowanceManagement
                        finish={() => this.setState({ showShiftAllowanceManagement: false })}
                        schedulerData={schedulerData}
                    />
                }
                {
                    ((urgentCallEditing?.userId && urgentCallEditing?.weekNumber) || showUrgentShiftModal) &&
                    <Modal
                        size="xl"
                        backdrop="static"
                        show
                    >
                        <Modal.Header>
                            <Modal.Title>{t('Urgent Management')}</Modal.Title>
                            <img
                                src={CloseModalIcon}
                                className="cursor-pointer"
                                onClick={this.handleCloseUrgentShiftModal}
                                alt={'close-icon'}
                            />
                        </Modal.Header>
                        <Modal.Body>
                            <UrgentCallManagement
                                handleCloseUrgentShiftModal={this.handleCloseUrgentShiftModal}
                                urgentCallEditing={urgentCallEditing}
                            />
                        </Modal.Body>
                    </Modal>
                }
            </>
        );
        return (
            <div className='RBS-Scheduler-header'>
                {this.renderCurrentWeekBanner()}
                {schedulerHeader}
            </div>
        )
    }
}
export default inject('scheduleStore', 'userStore', 'commonStore', 'shiftAllowanceStore')(withLocalization(applicationRouter(observer(ScheduleWeekHeader))));